export const PIRAEUS_CONSUMER_INTEREST = 10.95
export const PIRAEUS_CONSUMER_CONTRIBUTION = 0.6
export const PIRAEUS_CONSUMER_MAX_LOAN_AMOUNT = 15000
export const PIRAEUS_CONSUMER_MIN_LOAN_AMOUNT = 500
